import { connect, useSelector } from "react-redux";
import { PreviewGameCourtStyles as styles } from "./PreviewGameCourt.tailwind";
// import location_icon from "../../../../../../assets/svgs/location_icon.svg";
import back_btn from "../../../../../../assets/svgs/back_btn.svg";
import leaderboard_svg from "../../../../../../assets/svgs/leaderboardTab.svg"
import { ReactComponent as ExpandIcon } from "../../../../../../assets/svgs/expand.svg";
import { ReactComponent as ShortScreenIcon } from "../../../../../../assets/svgs/short-screen.svg";
import { getCommentaryPosition, getSportCourt } from "../../../../../../pages/SportPage/sportPageData";
import SportCourt from "../../../../../Sports/SportCourt";
import { getOwnedTokens } from "../../../../../../redux/slices/deployTokenSlice";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { TEAM_TYPE, isCurrentGameEnded } from "../../../../../GameScorer/Scorers/BasketballScorer/basketballScorer.data";
import { getCurrentTimestamps, getTimeStamps } from "../../../../../../lib/utils/dateAndTimeFormatting";
import GameScoreAndTimer from "../GameScoreAndTimer/GameScoreAndTimer";
import { LiveGameTimerProvider } from "../../../../../../context/GameTimer";
import routeConstant from "../../../../../../lib/constants/routeConstant";
import { MY_ACCOUNT_TABS } from "../../../../myAccountTabsData";
import { setMyAccountActiveTab } from "../../../../../../redux/slices/publicSlice";
import PreviewCommnetary from "./PreviewCommnetary";
import { COMMENTARY_POSITION, COURT_SEASON_CODES } from "../../../../../../lib/utils/sportCourtConfigs";

const PreviewGameCourt = ({ zonesToBeHighlighted, isFullScreened, commentary, handleOpenExpandedLeaderboard, setIsFullScreened, isLiveGame, tabValue, showPoints, popupPoint, purchasedTokens, replayedMessage, socket, setActiveTab }) => {
  const navigate = useNavigate();
  const apiDataRef = useRef(false);
  const { gameId } = useParams();
  
  const { gameDetails } = useSelector(state => state.scorer);
  const { tokens, tokenLoading } = useSelector((state) => state.deployToken);
  const { currentSeason } = useSelector(state => state.seasons);
  const checkSportGround = getSportCourt(currentSeason?.seasonCode);

  const [teamDetails, setTeamDetails] = useState([]);

  const enterFullScreen = () => {
    const docElement = document.documentElement;
    if (docElement.requestFullscreen) {
      docElement.requestFullscreen();
    } else if (docElement.mozRequestFullScreen) {
      docElement.mozRequestFullScreen();
    } else if (docElement.webkitRequestFullscreen) {
      docElement.webkitRequestFullscreen();
    } else if (docElement.msRequestFullscreen) {
      docElement.msRequestFullscreen();
    }
    setIsFullScreened(true);
  };

  const exitFullScreen = () => {
    if (
      document.hasFocus() &&
      (document.fullscreenElement ||
       document.mozFullScreenElement ||
       document.webkitFullscreenElement ||
       document.msFullscreenElement)
    ) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
    setIsFullScreened(false);
  };

   const handleBack = () => {
    setActiveTab(MY_ACCOUNT_TABS.VIEW_GAMES); // Dispatch action to set active tab to VIEW_GAMES
    navigate(routeConstant.MY_ACCOUNT_PAGE, { replace: true }); // Navigate to MY_ACCOUNT_PAGE
  }

  const handleExpand = () => {
    if(isFullScreened) {
      exitFullScreen();
    }else {
      enterFullScreen();
    }
  }

  const getZoneName = (_commentaryMessage) => {
    const validZones = [_commentaryMessage?.player1Zone, _commentaryMessage?.player2Zone]
      .filter((zone) => zone !== undefined) // Remove undefined values
      .map((zone) => zone?.replace('Z', '')); // Extract only the number part

      if(validZones?.length === 0) {
        return null;
      }

      return validZones[validZones.length - 1];
  }

  const callApi = useCallback(async () => {
    if (apiDataRef.current || !currentSeason?._id) return;
    apiDataRef.current = true;

    // data to be sent in purchased-tokens
    const data = {
      seasonId: currentSeason._id,
      matchId: gameId,
    };

    await purchasedTokens(data);
  }, [currentSeason]);

  useEffect(() => {
    if (currentSeason) {
      callApi();
    }
  }, [callApi, currentSeason]);

  useEffect(() => {
    const _homeTeamDetails = {
      teamId: gameDetails?.homeTeamId,
      teamName: gameDetails?.homeTeamName,
      teamType: TEAM_TYPE.HOME_TEAM,
      teamImage: gameDetails?.homeTeamImage,
      teamScore: gameDetails?.homeTeamScore,
      substitutePlayer: gameDetails?.homeTeamPlayers?.filter(team => !team?.isCurrentlyPlaying),
      teamPlayers: gameDetails?.homeTeamPlayers?.filter(team => team?.isCurrentlyPlaying),
    };

    const _awayTeamDetails = {
      teamId: gameDetails?.awayTeamId,
      teamName: gameDetails?.awayTeamName,
      teamType: TEAM_TYPE.AWAY_TEAM,
      teamImage: gameDetails?.awayTeamImage,
      teamScore: gameDetails?.awayTeamScore,
      substitutePlayer: gameDetails?.awayTeamPlayers?.filter(team => !team?.isCurrentlyPlaying),
      teamPlayers: gameDetails?.awayTeamPlayers?.filter(team => team?.isCurrentlyPlaying),
    };

    const arr = [
      _homeTeamDetails,
      _awayTeamDetails
    ];

    setTeamDetails(arr);
  }, [gameDetails]);

  if (!checkSportGround || tokenLoading) {
    return (
      <div className={`${styles.live_game_section} ${isFullScreened ? '!h-[100vw] !max-h-[100vw] !min-h-[100vw] !overflow-auto' : ''}`}>
        <div className='w-full min-h-[150px] h-full max-h-full flex items-center justify-center'>
          <div className="w-full h-full min-h-[inherit] max-h-[inherit] bg-gray-500 animate-pulse" />
        </div>
      </div>
    )
  }

  return (
    <div className={`${styles.live_game_section} ${isFullScreened ? '!h-[100vw] !max-h-[100vw] !min-h-[100vw] !overflow-auto' : ''}`}>
      <button className={styles.back_btn} onClick={handleBack}>
        <img src={back_btn} alt="back" className="max-w-[18px]" />
      </button>

      <button className={styles.expand_btn} onClick={handleExpand}>
        {
          isFullScreened ? (
            <ShortScreenIcon className="max-w-[18px] h-auto invert-[1]" />
          ) : (
            <ExpandIcon className="max-w-[18px] h-auto invert-[1]" />
          )
        }
      </button>

      {/* Sport Court */}
      <div className={`w-full h-full flex items-center justify-center ${isFullScreened ? 'max-w-[650px]' : ''}`}>
        <SportCourt
          disableModal={true}
          previewGame={true}
          showHoveredTooltip={false}
          tokensToShowOnGround={[]}
          CourtGround={checkSportGround}
          // makeSelectable={makeSelectable}
          isLiveGame={isLiveGame}
          zonesToBeHighlighted={zonesToBeHighlighted}
          // selectZone={selectZone}
          hideHover={true}
          purchasedTokens={tokens}
          teamDetails={(gameDetails.homeTeamDefensiveBasketZone > 1) ? [...teamDetails].reverse() : [...teamDetails]}
          disableTokenHover={true}
          showZoneOnMobileScreen={tabValue === 3}
          currentCommentary={replayedMessage ? {...replayedMessage} : {...commentary}}
        />
      </div>

      {/* + points */}
      {!replayedMessage && (
        <div
          className={`absolute ml-3 transform transition-all duration-700 ease-out top-20 left-0
            ${showPoints ? 'opacity-100 -translate-y-7' : 'opacity-0'}
            screen-500:top-[26px] screen-500:left-[15px]
          `}
        >
          <span className="text-base z-10 text-[#B98B00] font-semibold">+{popupPoint} pts</span>
        </div>
      )}

      {/* Commentary to display on Court */}
      {!replayedMessage && commentary && commentary?.replayText && (
        <PreviewCommnetary
          commentaryText={commentary?.replayText}
          homeTeamScore={commentary?.homeTeamScore}
          awayTeamScore={commentary?.awayTeamScore}
          isFullScreen={isFullScreened}
          hideScores={true}
          zone={() => getZoneName(commentary)}
        />
      )}

      {/* This component is for replayed commentary (on pressing replay button) */}
      {replayedMessage && (
        <PreviewCommnetary
          commentaryText={replayedMessage?.replayText}
          homeTeamScore={replayedMessage?.homeTeamScore}
          awayTeamScore={replayedMessage?.awayTeamScore}
          isFullScreen={isFullScreened}
          zone={() => getZoneName(replayedMessage)}
        />
      )}

      {/* Chip for Game Ended/ Live */}
      {!isFullScreened && (
        <CurrentGameStatusChip
          replayedMessage={replayedMessage}
          commentary={commentary}
          gameDetails={gameDetails}
          isFullScreened={isFullScreened}
          getZoneName={getZoneName}
        />
      )}

      {/* <div className={`${styles.complexNameSection}`}>
        <img src={location_icon} alt="Location" className={styles.image} />
        <p className={styles.complexName}>{gameDetails?.sportsComplexName}</p>
      </div> */}

      <div className={styles.mobile_score_display_design}>
        {/* Chip for Game Ended/ Live */}
        {isFullScreened && (
          <CurrentGameStatusChip
            commentary={commentary}
            replayedMessage={replayedMessage}
            gameDetails={gameDetails}
            isFullScreened={isFullScreened}
            getZoneName={getZoneName}
          />
        )}
        
        <LiveGameTimerProvider>
          <GameScoreAndTimer socket={socket} />
        </LiveGameTimerProvider>
      </div>

      {isFullScreened && (
        <button className={styles.open_leaderboard} onClick={handleOpenExpandedLeaderboard}>
          <img src={leaderboard_svg} alt="leaderboard" className="max-w-[30px] h-auto" />
        </button>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  purchasedTokens: (data) => dispatch(getOwnedTokens(data)),
  setActiveTab: (data) => dispatch(setMyAccountActiveTab(data))
});

export default connect(null, mapDispatchToProps)(PreviewGameCourt);

const CurrentGameStatusChip = ({ replayedMessage, gameDetails, isFullScreened, getZoneName, commentary }) => {
  const { currentSeason } = useSelector(state => state.seasons);

  const _zone = getZoneName(replayedMessage || commentary);
  const isFootball = currentSeason?.seasonCode === COURT_SEASON_CODES.FOOTBALL;
  const positioning = _zone ? getCommentaryPosition(_zone, currentSeason?.seasonCode) : COMMENTARY_POSITION.PRIMARY;
  const isEnded = isCurrentGameEnded(gameDetails);

  return (
    <div className={`${styles.headerSection} ${isFullScreened ? '!static mr-3' : ''}
      ${isFootball 
        ? "bottom-2 left-2" 
        : positioning === COMMENTARY_POSITION.PRIMARY ? "bottom-2 right-0 screen-500:right-[unset] screen-500:left-2" : "top-14 left-0 screen-500:top-2 screen-500:left-2"}
    `}>
        {replayedMessage ? (
          <div className={styles.replayedContainer}>
            <div className={styles.replayedIndicator} />
            <span className={`${styles.gameText} !text-[#B98B00]`}>REPLAY</span>
          </div>
        ): isEnded ? (
          <div className={styles.endedContainer}>
            <div className={styles.endedIndicator} />
            <span className={`${styles.gameText} !text-red-500`}>ENDED</span>
          </div>
        ) : (getTimeStamps(gameDetails?.matchStartDatetime) > getCurrentTimestamps()) ? (
          null
        ) : (
          <div className={styles.liveContainer}>
            <div className={styles.liveIndicator} />
            <span className={styles.gameText}>LIVE</span>
          </div>
        )}          
      </div>
  )
}